/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIPart } from './APIPart';
import {
    APIPartFromJSON,
    APIPartFromJSONTyped,
    APIPartToJSON,
} from './APIPart';

/**
 * 
 * @export
 * @interface APIPaginatedPartList
 */
export interface APIPaginatedPartList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedPartList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedPartList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedPartList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIPart>}
     * @memberof APIPaginatedPartList
     */
    results: Array<APIPart>;
}

/**
 * Check if a given object implements the APIPaginatedPartList interface.
 */
export function instanceOfAPIPaginatedPartList(value: object): value is APIPaginatedPartList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedPartListFromJSON(json: any): APIPaginatedPartList {
    return APIPaginatedPartListFromJSONTyped(json, false);
}

export function APIPaginatedPartListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedPartList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIPartFromJSON)),
    };
}

export function APIPaginatedPartListToJSON(value?: APIPaginatedPartList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIPartToJSON)),
    };
}

